import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const create3DCollection=(request,token)=>async dispatch=>{
    dispatch({
        type:actionTypes.CREATE_3D_COLLECTION_START
    })
    const options={
        url:`${api}/threeDCollections`,
        method:'POST',
        headers:{
            'Authorization':`Bearer ${token}`
        },
        data:request
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.CREATE_3D_COLLECTION_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.CREATE_3D_COLLECTION_FAIL,
                payload:getMessage(error)
            }))
}